import { View, ViewProps } from 'react-native';
import { cn } from '@/lib/utils';
import { LayoutBreakpoints } from '@/constants/LayoutBreakpoints';
import { useIsWidthUp } from '@/features/global/hooks/useIsWidthUp';
import { CurrentUserAvatar } from '@/features/user/components/current-user-avatar/CurrentUserAvatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Text } from '@/components/ui/text';
import { useAuth } from '@/features/auth/contexts/auth/Auth';
import { useTranslation } from 'react-i18next';
import { DropdownMenuItemIcon } from '@/features/extension/components/dropdown-menu-item-icon/DropdownMenuItemIcon';

export interface SidebarLayoutHeaderProps extends ViewProps {}

export const SidebarLayoutHeader = ({
  className,
  children,
  ...props
}: SidebarLayoutHeaderProps) => {
  const { t } = useTranslation('navigation');
  const { handleLogout } = useAuth();
  const isDesktop = useIsWidthUp(LayoutBreakpoints.tablet);

  // Desktop-only header. Conditionally rendered (not `display:none` via
  // `hidden md:flex`) so the phone-hidden node is never in the tree — a
  // re-rendering phone-`display:none` node crashes iOS New Arch (RN #52349).
  if (!isDesktop) {
    return null;
  }

  return (
    <View
      {...props}
      className={cn(
        className,
        'pl-4 md:pl-20 pr-4 py-4 border-b border-border w-full flex flex-row items-center justify-between bg-background gap-6',
      )}
    >
      <View className="flex flex-1 flex-row items-center justify-between">
        {children}
      </View>
      <DropdownMenu className="flex">
        <DropdownMenuTrigger asChild>
          <CurrentUserAvatar />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onPress={handleLogout}>
            <DropdownMenuItemIcon name="LogOut" size={20} />
            <Text className="text-sm">{t('logout')}</Text>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </View>
  );
};
